<template lang="pug">
  sui-segment(vertical)
    sui-statistics-group(:columns="stats.length")
      sui-statistic(
        in-group
        v-for="stat, i in stats",
        :key="i")
        sui-statistic-value {{ stat.value }}
        sui-statistic-label {{ stat.label }}

</template>

<script>
export default {
  name: 'AppStatistics',
  props: {
    stats: {
      required: true,
    },
  },
};
</script>
